var _defs, _style, _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCPad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41 50",
    width: 41,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "template") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 37,
    height: 49,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAxCAMAAABqB5C8AAAAAXNSR0IB2cksfwAAAGBQTFRFAAAAICAkISAlISAlICAkICAjICAkISAmICAkICAlICAlICAkICAoICAlICAlICAkICAmISEhICAkICAjICAgISAlISEmICAkIiAmISAlICAlICAlIiAkISAkISAkISAlbPXITwAAACB0Uk5TAH/f/89fv9+vb99AIM8wP18fj58Q7y9Pr7+fYK+/788gXlEkAAABjUlEQVR4nLWVUZeCIBCFgdk0zAINpKyt//8vdwYzgRAfOnufPPodmLl3QMYYF1DQz46RKoC6IIA9QhKaAyuoFcAZO8KpBDGmQDAGUIYmwlOtXlEXUse1DquQqqHnGfVUUkh12f6+ouTZbFMcIKSM6DMUB7sr+DVRCA24aWVKlPYQoksn3H1Qw2WY15vrgmu2xwjCJk2OGqEJoWz1BMXuuu6TalMo7+oh8eC7HDcokVVM9WuzGqVd1H9Rg1IqSqetxHRHBJTzxaoA8neMi6kbNKOAYFI13iI6Po9SWDhj2FbImZL4QqXzBSDxA3gbvYyFyvrFPxKaImFGYYFKgJUsppyij9pTOwt+hkziRO3DoJyOtCDcha87odz466uvRkmm7PFcPHKu3rC/qVh2wuHntOhMPd6UIg/tdHlW9Py2ztuRy1Ffx+VG7ml8NtMWdD1vUfzt/7LVPKNBVdCl1PB8/THcDFn6J5ChwbgkMugzf+3bZE8Z5sXtK0nUHfLHjMo7LwvoZ/aQ1Rdpspus6g+cqBWe43vUMAAAAABJRU5ErkJggg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\ttspan { white-space:pre } \r\n\t")), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Layer 1",
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCPad);
export default __webpack_public_path__ + "static/media/cPad.e9eae643dc19dbedfb5f4cf3d545ce15.svg";
export { ForwardRef as ReactComponent };